import store from "@/store";
import {
	setStore,
	checkAccess,
	clearCookies,
	getToken,
	getRefreshToken,
	checkTokenExpiry,
} from "@/utils/tokenCheck";
import { apiRequest } from "@/views/profile/api-client/profile";
import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/login",
		name: "Login",
		component: () => import("@/views/LoginPage.vue"),
	},

	{
		path: "/",
		name: "Layout",
		redirect: "/kanban",
		component: () => import("@/views/Layout.vue"),
		children: [
			{
				path: "/coursecreation",
				name: "coursecreation",
				component: () => import("@/views/course-creation/CourseCreation.vue"),
				meta: {
					title: "Create Course",
				},
			},
			{
				path: "/kanban",
				name: "kanban",
				component: () => import("@/views/kanban/Kanban.vue"),
				meta: {
					title: "My Courses",
					isSidebarComponent: true,
				},
			},
			{
				path: "/profile",
				name: "profile",
				component: () => import("@/views/profile/Profile.vue"),
				meta: {
					title: "My Profile",
					isSidebarComponent: true,
				},
			},
			{
				path: "/ratings",
				name: "ratingsreviews",
				component: () => import("@/views/ratings-reviews/RatingsReviews.vue"),
				meta: {
					title: "Reviews",
					isSidebarComponent: true,
				},
			},
			{
				path: "/assetbank",
				name: "assetbank",
				component: () => import("@/views/asset-bank/AssetBank.vue"),
				meta: {
					title: "Asset Bank",
					isSidebarComponent: true,
				},
			},
			{
				path: "/questionbank",
				name: "QuestionBank",
				component: () => import("@/views/question-bank/QuestionBank.vue"),
				meta: {
					title: "Question Bank",
					isSidebarComponent: true,
				},
			},
			{
				path: "/previewcourse/:courseID",
				name: "previewcourse",
				component: () => import("../views/preview-course/PreviewCourse.vue"),
				meta: {
					title: "Preview Course",
				},
			},
			{
				path: "CourseDetailSection",
				name: "CourseDetailSection",
				component: () =>
					import("../views/preview-course/components/CourseContent.vue"),
			},
			{
				path: "candidateoverview",
				name: "CandidateOverview",
				component: () => import("./../views/candidate/CandidateOverview.vue"),
				meta: {
					title: "Candidates Overview",
					isSidebarComponent: true,
				},
			},
			{
				path: "candidatedetails/:courseID/:candidateUserID",
				name: "CandidateDetails",
				component: () => import("./../views/candidate/CandidateDetails.vue"),
				meta: {
					title: "Candidate Details",
				},
			},
			{
				path: "community",
				name: "Community",
				component: () => import("../views/community/Community.vue"),
				meta: {
					title: "Community",
					isSidebarComponent: true,
				},
			},
			{
				path: "coupons",
				name: "Coupons",
				component: () => import("../views/coupons/Coupons.vue"),
				meta: {
					title: "Coupons",
				},
			},
			{
				path: "pricing",
				name: "Pricing",
				component: () => import("../views/pricing/Pricing.vue"),
				meta: {
					title: "Pricing",
					isSidebarComponent: true,
				},
			},
			{
				path: "Transactions",
				name: "Transactions",
				component: () => import("../views/transactions/Transactions.vue"),
				meta: {
					title: "Transactions",
					isSidebarComponent: true,
				},
			},
			{
				path: "accountsettings",
				name: "AccountSettings",
				component: () => import("../views/Accountsettings/AccountSettings.vue"),
				meta: {
					title: "Account Settings",
					isSidebarComponent: true,
				},
			},
			{
				path: "billspayments",
				name: "BillsPayments",
				component: () => import("../views/Billspayments/Billspage.vue"),
				meta: {
					title: "Bills & Payments",
					isSidebarComponent: true,
				},
			},
			{
				path: "/coursedetail",
				name: "coursedetail",
				component: () => import("@/views/course-detail/CourseDetail.vue"),
				meta: {
					title: "Course Detail",
				},
			},
		],
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

const isAllFilled = (data) => {
	const { firstName, lastName, phoneNumber, bio, headline } = data;
	return firstName && lastName && phoneNumber && bio && headline;
};

const checkProfile = async (to, next) => {
	if (
		to.query.from &&
		(to.query.from === "login" || to.query.from === "candidate")
	) {
		try {
			const response = await apiRequest("get");
			if (response.status === 200) {
				const data = response.data.data.instructorInfo;
				if (!isAllFilled(data)) {
					next({ path: "/profile" });
				} else {
					next();
				}
			}
		} catch (error) {
			console.log(error);
			next();
		}
	} else {
		next();
	}
};

router.beforeEach(async (to, from, next) => {
	if (to.meta && to.meta.title) {
		document.title = to.meta.title + " - Admin";
	} else {
		document.title = "Training Admin"; // Default title
	}
	if (to.path === "/login" || to.path === "/forgotpassword") {
		next();
	} else if (checkAccess("training")) {
		const hasToken = getToken();
		const expiryTime = checkTokenExpiry();
		if (hasToken && expiryTime) {
			if (
				store.getters.userDetails &&
				typeof store.getters.userDetails === "object" &&
				Object.keys(store.getters.userDetails).length === 0
			) {
				let userData = await store.dispatch("userVUEX/getUserData");
				if (userData) {
					setStore(getToken(), getRefreshToken(), true);
					checkProfile(to, next);
				} else {
					clearCookies();
					// location.replace("http://localhost:8080/login?from=training");
					location.replace("https://app.hire3x.com/login?from=training");
				}
			} else {
				checkProfile(to, next);
			}
		} else {
			clearCookies();
			// location.replace("http://localhost:8080/login?from=training");
			location.replace("https://app.hire3x.com/login?from=training");
		}
	} else if (
		getToken() &&
		!checkAccess("training") &&
		checkAccess("candidate")
	) {
		// location.replace("http://localhost:8083/builder/becomeinstructor");
		location.replace("https://candidate.hire3x.com/builder/becomeinstructor");
	}
	 else {
		clearCookies();
		// location.replace("http://localhost:8080/login?from=training");
		location.replace("https://app.hire3x.com/login?from=training");
	}
});

export default router;
